module.exports = __webpack_public_path__ + "static/media/front-page-poster.7454a174.webp";